import{b as r}from"./chunk-V2DQWH6R.js";import{a as e}from"./chunk-DMS2IT2J.js";import{m as t}from"./chunk-HBP5N4FR.js";t();function c(){return r(e.getState())}export{c as a};
//# sourceMappingURL=chunk-4UGYM57L.js.map
